import { render, staticRenderFns } from "./docs_page.vue?vue&type=template&id=1bf35524&scoped=true&"
import script from "./docs_page.vue?vue&type=script&lang=js&"
export * from "./docs_page.vue?vue&type=script&lang=js&"
import style0 from "./docs_page.vue?vue&type=style&index=0&id=1bf35524&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf35524",
  null
  
)

export default component.exports